import { useNavigate } from "react-router-dom";
import Tool from "./tool";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

export default function Notice() {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const refreshKey = i18n.language;

  return (
    <Tool
      key={refreshKey}
      url="/system/nftNotice/list"
      title={t("announcement.news_title")}
      orderByColumn="create_time"
    >
      {({ list, pageNum, pageSize, paging }) => (
        <div className="official-table">
          <table>
            <thead>
              <tr>
                <td>No</td>
                <td>{t("announcement.Title")}</td>
                <td>{t("announcement.date_posted")}</td>
                <td>{t("announcement.Views")}</td>
              </tr>
            </thead>
            <tbody>
              {
              list.map((item, idx) => (
                <tr
                  className="cursor-pointer"
                  key={item.id}
                  onClick={() =>
                    navigate("/announcement/notice-detail?id=" + item.id)
                  }
                >
                  <td>{paging.getTotal() - ((pageNum - 1) * pageSize + idx)}</td>
                  <td>{item.title}</td>
                  <td>{dayjs(item.createTime).format("YY.MM.DD HH:mm:ss")}</td>
                  <td>{item.click}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Tool>
  );
}
